import wrapperRequest from '@/utils/request';

export async function getMetaData(body: any, type: string) {
  const res = await wrapperRequest<API.UserTitleListResult>(`/erpanlam-hrm/metadata/${type}/list`, {
    method: 'POST',
    data: body,
  });
  return {
    data: res?.data?.list ?? [],
    success: res?.success,
    total: res?.data?.total ?? 0,
  };
}

export async function getMetaDataAll(body: any) {
  const res = await wrapperRequest<any>(`/erpanlam-hrm/metadata/all-metadata`, {
    method: 'POST',
    data: body,
  });
  return res;
}
// TypeScript interfaces
export interface Metadata {
  id?: number;
  code?: string;
  name: string;
  parentId?: number;
  description?: string;
  priority: number;
  status: number;
}

export interface MetadataListParams {
  pageSize?: number;
  pageIndex?: number;
  name?: string;
  status?: number;
  companyId?: number;
}

export interface MetadataListResponse {
  total: number;
  pageSize: number;
  pageIndex: number;
  list: Metadata[];
}

// API Services
export async function metadataList(type: string, params?: MetadataListParams) {
  return wrapperRequest<BaseResponse<MetadataListResponse>>(`/erpanlam-hrm/metadata/${type}/list`, {
    method: 'POST',
    data: {
      pageSize: 1000000,
      pageIndex: 0,
      ...params,
    },
  });
}

export async function metadataListForExternal(type: string, params?: MetadataListParams) {
  return wrapperRequest<BaseResponse<MetadataListResponse>>(
    `/erpanlam-hrm/metadata/${type}/list-for-external`,
    {
      method: 'POST',
      data: {
        pageSize: 1000000,
        pageIndex: 0,
        ...params,
      },
    }
  );
}

export async function metadataCreate(type: string, data: Omit<Metadata, 'id' | 'code'>) {
  return wrapperRequest<Metadata>(`/erpanlam-hrm/metadata/${type}/create`, {
    method: 'POST',
    data: {
      code: null,
      parentId: 0,
      ...data,
    },
  });
}

export async function metadataUpdate(type: string, data: Metadata) {
  return wrapperRequest<Metadata>(`/erpanlam-hrm/metadata/${type}/update`, {
    method: 'POST',
    data,
  });
}

export async function metadataShow(type: string, id: number) {
  return wrapperRequest<Metadata>(`/erpanlam-hrm/metadata/${type}/${id}`, {
    method: 'GET',
  });
}

export async function metadataDelete(type: string, id: number) {
  return wrapperRequest<null>(`/erpanlam-hrm/metadata/${type}/delete/${id}`, {
    method: 'POST',
  });
}

export async function titleGroupList(params?: MetadataListParams) {
  return wrapperRequest<MetadataListResponse>(`/erpanlam-hrm/metadata/title_group/list`, {
    method: 'POST',
    data: {
      pageSize: 10,
      pageIndex: 0,
      ...params,
    },
  });
}
